import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Content from '../../components/layout/Content';
import BundlesEditor from './bundles/BundlesEditor';

const BundlesCMS = () => {
    const navigate = useNavigate();

    return (
        <Content>
            <div className='container mx-auto py-10'>
                <div className='flex items-center gap-4 mb-6'>
                    <Button variant='ghost' size='icon' onClick={() => navigate('/cms')}>
                        <ArrowLeft className='h-4 w-4' />
                    </Button>
                    <div>
                        <h1 className='text-3xl font-bold'>Bundles</h1>
                        <p className='text-muted-foreground'>
                            Verwalten Sie Bundles für Behandlungsvarianten. Bundles ermöglichen Kunden, mehrere Sitzungen zu einem reduzierten Preis zu kaufen.
                        </p>
                    </div>
                </div>

                <BundlesEditor />
            </div>
        </Content>
    );
};

export default BundlesCMS;
